<template>
	<div>
		<div style="display:flex;">
			<div>
				<div class="inputItemDiv"><div class="inputTitleDiv">アカウントID</div><input :class="accountCssClass" :readonly="readonly" type="text" v-model="account.userid"></div>
				<div class="inputItemDiv" v-show="!resAccountIdVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。45桁以内で入力して下さい。</span></div>
				<div class="inputItemDiv" v-show="!resAccountIdEmailVal"><div class="inputErrorTitleDiv"></div><span class="validateError">メールアドレスの形式で入力して下さい。</span></div>


				<div class="inputItemDiv"><div class="inputTitleDiv">ユーザ名</div><input class="input" type="text" v-model="account.name"></div>
				<div class="inputItemDiv" v-show="!resNameVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。45桁以内で入力して下さい。</span></div>


				<div class="inputItemDiv"><div class="inputTitleDiv">取引先CD</div><input class="input" type="text" v-model="account.supplierscd"></div>
				<div class="inputItemDiv" v-show="!resSuppliersCdVal"><div class="inputErrorTitleDiv"></div><span class="validateError">45桁以内で入力して下さい。</span></div>


				<div class="inputItemDiv"><div class="inputTitleDiv">会社名</div><input class="input" type="text" v-model="account.companyname"></div>
				<div class="inputItemDiv" v-show="!resCompanyNameVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。100桁以内で入力して下さい。</span></div>

				<div class="inputItemDiv"><div class="inputTitleDiv">部署役職</div><input class="input" type="text" v-model="account.department"></div>
				<div class="inputItemDiv" v-show="!resDepartmentVal"><div class="inputErrorTitleDiv"></div><span class="validateError">100桁以内で入力して下さい。</span></div>

				<div class="inputItemDiv"><div class="inputTitleDiv">ウォーターマーク</div><input class="input" type="text" v-model="account.watermark"></div>
				<div class="inputItemDiv" v-show="!resWaterMarkVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。30桁以内で入力して下さい。</span></div>

				<div class="inputItemDiv"><div class="inputTitleDiv inputAreaTitleDiv">備考</div><textarea class="inputArea" v-model="account.remark"></textArea></div>
				<div class="inputItemDiv" v-show="!resRemarkVal"><div class="inputErrorTitleDiv"></div><span class="validateError">255桁以内で入力して下さい。</span></div>
			</div>
			
			<div style="margin-left:10px;">
				<div class="inputItemDiv"><div class="inputTitleDiv">一括メール送信</div><input type="checkbox" v-model="account.isnoticemail" /></div>
				<div class="inputItemDiv"><div class="inputTitleDiv">パスワード</div><input class="input" type="text" v-model="password"></div>
				<div class="inputItemDiv" v-show="!resPasswordVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。10桁以内で入力して下さい。</span></div>
				<div class="inputItemDiv" v-show="!resExitAccountVal"><div class="inputErrorTitleDiv"></div><span class="validateError">同じアカウントIDが存在しています。</span></div>

			</div>
	
		</div>
		<br>
		<br>
		<div style="text-align:center;width:100%;">
			<button  type="button" class="button" @click='cancel'>ｷｬﾝｾﾙ</button>
			<button :disabled="resAllVal"  type="button" class="button" @click='regist'>登録</button>
		</div>

	</div>

</template>

<script>
import accountValidator from '../composables/AccountValidator'
import accountRepository from '../composables/AccountRepository'
import { ref } from 'vue'
export default ({
  name: 'EditAccount',
  props: {
    id: String
  },

  setup(props, context){
  
    const accountCssClass = ref("input")
    const readonly = ref(false)
    
    const resExitAccountVal = ref( true )
    const account = ref({id:'',name:'',companyId:'', isnoticemail:true})
    const password = ref("")
  
    //AccountRepositoryモジュールからの変数、メソッドを宣言
    const { getAccountById, registAccount, checkExistUserId} = accountRepository()

    
        //データ取得時のコールバック
    const getCallback = ( result, data ) =>{
      if( result != "success"){
        context.emit( 'setMessage', result )
      }else{
        accountCssClass.value = "inputread"
        readonly.value = true
        account.value = data
      }
    }
    
    //パラメータでIDが渡された際は、データを取得する
    if( props.id != null ){
      getAccountById( props.id, getCallback  )
    }
    


    //accountValidatorモジュールからの変数、メソッドを宣言
    //resName:名称入力チェック結果
    //resPricceVal:価格入力チェック結果
    //resAllVal:全ての項目の入力チェック結果
    
    const{
      resRemarkVal,
      resAccountIdVal,
      resNameVal,
      resCompanyNameVal,
      resDepartmentVal,
      resWaterMarkVal,
      resPasswordVal,
      resSuppliersCdVal,
      resAccountIdEmailVal,
      resAllVal
    } = accountValidator( account, password )

	const checkExistUserIdCallback = (result) =>{
      if( result == "ok"){
        registAccount( account.value, regCallback )
      }else{
        resExitAccountVal.value = false
      }
    }


    //登録ボタン押下時の処理
    const regist = () => {
      if( account.value.id == null || account.value.id.length == 0 ){
        account.value.password = password.value
      }else{
        if( password.value != null && password.value.length != 0 ){
          account.value.password = password.value
        }
      }
      checkExistUserId( account.value, checkExistUserIdCallback )
    }
    

    
    //登録ボタン押下時のコールバック( accountRepositoryのregistaccountメソッドに渡す)
    const regCallback = ( result, data ) =>{
      if( result == "success"){
        context.emit( 'setMessage', "登録完了" )
        
        //登録したアカウントをリストに追加するように依頼
        context.emit( 'addRegistedAccountToList', data )
      }else{
        context.emit( 'setMessage', result )
      }
      
      context.emit( 'setIsEdit', false )
    }
    
    //ｷｬﾝｾﾙ処理 商品一覧画面へ戻る
    const cancel = () => {
      console.log("cancel")
      context.emit( 'setIsEdit', false )
    }
    
    
    //template上で使用する変数を宣言
    return{
      account,
      regist,
      cancel,
      resRemarkVal,
      resAccountIdVal,
      resNameVal,
      resCompanyNameVal,
      resDepartmentVal,
      resWaterMarkVal,
      resPasswordVal,
      resSuppliersCdVal,
      resAccountIdEmailVal,
      resAllVal,
      resExitAccountVal,
      accountCssClass,
      readonly,
      password
    }
  }

})

</script>



